<div class="background-hover" [formGroup]="challengeFormGroup">
    <div class="row">
        <div class="col-8">
            <div class="float-end">
                <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteChallenge()" *ngIf="!deleteChallengeVisible">
                    <i class="fas fa-trash-alt"></i> Delete
                </button>
                <button class="btn btn-sm btn-danger" (click)="deleteChallenge()" *ngIf="deleteChallengeVisible">
                    <i class="fas fa-exclamation-circle"></i> Confirm
                </button>
            </div>
            <div>
                <code>#{{ challenge.id }}</code>
                <small>
                    ({{ challenge.nbMembers }} <i class="fas fa-users"></i>)
                </small>
            </div>
            <div class="clearfix"></div>
            <div class="row">
                <div class="col-6">
                    <div class="mb-3">
                        <label for="challengeNameInput_{{ challenge.id }}">Name</label>
                        <input type="text" class="form-control" id="challengeNameInput_{{ challenge.id }}" formControlName="challengeNameInput" readonly>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeStartInput_{{ challenge.id }}">Start</label>
                        <input type="text" class="form-control" id="challengeStartInput_{{ challenge.id }}" formControlName="challengeStartInput" readonly>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeEndInput_{{ challenge.id }}">End</label>
                        <input type="text" class="form-control" id="challengeEndInput_{{ challenge.id }}" formControlName="challengeEndInput" readonly>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeTargetInput_{{ challenge.id }}">Target</label>
                        <input type="number" min="0" max="100000" class="form-control" id="challengeTargetInput_{{ challenge.id }}" formControlName="challengeTargetInput" readonly>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeTypeSelect_{{ challenge.id }}">Type</label>
                        <select class="form-select" id="challengeTypeSelect_{{ challenge.id }}" formControlName="challengeTypeSelect" readonly>
                            <option value="CAL">Calories (calories)</option>
                            <option value="DISTANCE">Distance (meters)</option>
                            <option value="DURATION">Duration (seconds)</option>
                            <option value="STEPS">Steps (steps)</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeOrderBySelect_{{ challenge.id }}">RankBy</label>
                        <select class="form-select" id="challengeOrderBySelect_{{ challenge.id }}" formControlName="challengeOrderBySelect" readonly>
                            <option value="CAL">Calories (calories)</option>
                            <option value="DISTANCE">Distance (meters)</option>
                            <option value="DURATION">Duration (seconds)</option>
                            <option value="STEPS">Steps (steps)</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <label for="challengeLimitInput_{{ challenge.id }}">LimitToBeRanked</label>
                        <input type="number" min="0" max="100000" class="form-control" id="challengeLimitInput_{{ challenge.id }}" formControlName="challengeLimitInput" readonly>
                    </div>
                </div>
            </div>
            <div *ngIf="challenge.details.length > 0">
                <div formArrayName="challengeDetailFormArray" *ngFor="let detailFormGroup of getChallengeDetailFormArray().controls; let i = index;">
                    <div [formGroupName]="i">
                        <challenge-detail [challenge]="challenge" [formGroup]="detailFormGroup" (refreshChallenges)="emitRefreshEvent()"></challenge-detail>
                    </div>
                </div>
            </div>
            <div>
                <h5 (click)="newLocaleChallengeVisible = !newLocaleChallengeVisible" style="cursor: pointer;">
                    Add a new description
                    <span *ngIf="!newLocaleChallengeVisible">
                        <i class="fas fa-caret-right align-text-bottom"></i>
                    </span>
                    <span *ngIf="newLocaleChallengeVisible">
                        <i class="fas fa-caret-down align-text-bottom"></i>
                    </span>
                </h5>
                <div [hidden]="!newLocaleChallengeVisible" [formGroup]="newLocaleChallengeFormGroup">
                    <div class="row">
                        <div class="col-3">
                            <div class="mb-3">
                                <input type="text" class="form-control" placeholder="Locale (en, fr, ...)" formControlName="newLocaleChallengeLocaleInput">
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <textarea type="text" class="form-control" placeholder="Description..." formControlName="newLocaleChallengeDetailInput"></textarea>
                    </div>
                    <div class="mb-3">
                        <button class="btn btn-sm btn-primary" [disabled]="newLocaleChallengeFormGroup.invalid" (click)="uploadNewChallengeLocale()">
                            <i class="fas fa-plus-circle"></i> Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div>
                <img class="img-fluid w-100" src="{{ challenge.urlMini }}">
            </div>
            <!--div class="mb-3">
                <img class="img-fluid w-100" src="{{ challenge.urlMini }}">
            </div-->
            <!--div>
                <img class="img-fluid w-100" src="{{ challenge.url }}">
            </div-->
        </div>
    </div>
</div>